import * as React from 'react'

interface Props {
    slot?: string
}

export function OtherFileGuide(props: Props) {
    return (
        <div className="AppCore__guide__OtherFileGuide" slot={props.slot}>
            Your guide is downloading...
        </div>
    )
}
